import { ReactNode, useEffect, useState } from "react";
import {
  userGetBookPayment,
  userGetSubcriptionPayment,
} from "../../apiservice/userService";
import { useNavigate, useSearchParams } from "react-router-dom";
import { formatCurrency } from "../../utils/basic.utils";
import {
  IBookPaymentResponse,
  IBookPaymentResponseData,
  ISubscriptionResponse,
  ISubscriptionResponseData,
} from "../../apiservice/userService.type";
import { Modal } from "antd";
import { appZIndex } from "../../utils/appconst";
import { IAuthType } from "../../apiservice/authService.type";
import { useAppSelector } from "../../Redux/reduxCustomHook";
import { RootState } from "../../Redux/store";

const SubscriptionPaymentLink = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [token, setToken] = useState<string>("");
  const [subPlanData, setSubPlanData] = useState<
    (ISubscriptionResponseData & IBookPaymentResponseData) | null
  >(null);

  const navigate = useNavigate();
  const [URLSearchParams] = useSearchParams();

  const authUserData: IAuthType = useAppSelector(
    (state: RootState) => state?.AuthData
  );

  const fetchSubscriptionLink = async () => {
    if (!authUserData?.data?.credentials?.email) {
      showSignInAlert(
        "Login To Your Account",
        "Please Login to your account to have access to this page.",
        "/auth"
      );
      return;
    }

    setLoading(true);
    try {
      const subPlan: ISubscriptionResponse & IBookPaymentResponse =
        URLSearchParams?.get("type") === "1"
          ? await userGetSubcriptionPayment({
              subscriptionPricingId: URLSearchParams?.get("id"),
              amount: URLSearchParams?.get("price"),
            })
          : await userGetBookPayment({
              bookId: URLSearchParams?.get("id"),
              amount: URLSearchParams?.get("price"),
            });

      setSubPlanData(subPlan?.data);
      if (subPlan) {
        setToken(subPlan?.data?.paymentToken);
      } else {
        setError("No Link Exist...");
      }
    } catch (err: any) {
      setError(
        err?.response.data?.message || "Failed to load Subcription Payment Link"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptionLink();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    window.open(
      process.env.REACT_APP_PUBLIC_URL +
        "explore/online-payment?token=" +
        token +
        "&type=" +
        URLSearchParams?.get("type") +
        "",
      "_blank"
    );
  };

  // Show Sign In Alert
  const showSignInAlert = (title: string, content: ReactNode, url: string) => {
    Modal.confirm({
      title,
      content,
      async onOk() {
        navigate(url);
      },
      onCancel() {
        console.log("Cancelled");
      },
      zIndex: appZIndex.modal,
    });
  };

  if (loading) {
    return (
      <div className="p-4 text-center dark:text-white">
        Loading Subscription details...
      </div>
    );
  }

  if (error || !token) {
    return (
      <div className="p-6 mt-6 bg-blue-50  rounded-md text-center text-blue-700 dark:bg-red-100/10  dark:text-blue-300">
        <h4 className="text-lg font-semibold mb-2">
          Oops! Something went wrong.
        </h4>
        <p className="mb-4 text-xl pt-4 pb-4">
          {error || "No Payment Token Available. Please try again later."}
        </p>
        <div className="flex justify-center gap-4">
          <button
            onClick={fetchSubscriptionLink}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md"
          >
            Retry
          </button>
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-gray-200 hover:bg-gray-300 dark:bg-stone-700 dark:hover:bg-stone-600 text-gray-800 dark:text-white rounded-md"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className=" p-6 bg-white dark:bg-stone-800 rounded-xl">
      <div className="mb-6 text-gray-900 dark:text-stone-100">
        <h3 className="text-lg font-semibold mb-2">Book/Payment Details</h3>
        <br />

        <p className="mb-1">
          Payment for:{" "}
          <span className="text-gray-600 dark:text-stone-400">
            {" "}
            &nbsp;{" "}
            {subPlanData?.subscriptionPricingTitle ||
              subPlanData?.bookTitle +
                " Book Summary By " +
                subPlanData?.book?.authorName ||
              URLSearchParams?.get("title")}
          </span>
        </p>
        <br />
        <p>
          Price:{" "}
          <span className="text-gray-600 dark:text-stone-400">
            {" "}
            &nbsp;{" "}
            {formatCurrency(
              subPlanData?.subscriptionPricing?.price ||
                subPlanData?.book?.price ||
                URLSearchParams?.get("price") ||
                0
            )}
          </span>
        </p>
        <br />
      </div>

      <form onSubmit={handleSubmit} className="mb-4">
        <button
          type="submit"
          className="w-full bg-blue-800 hover:bg-blue-700 dark:hover:bg-blue-600 text-white py-3 rounded-md text-lg font-medium"
        >
          Pay At Our Website
        </button>
      </form>

      <p className="text-xs text-gray-500 dark:text-stone-400 text-center">
        Cancellation Policy: Cancel at any time.
      </p>
    </div>
  );
};

export default SubscriptionPaymentLink;
